import React from 'react';
import OptionElement from './OptionElement';
import LeadFormSearch from './LeadFormSearch';

export default function CheckboxOption(props) {

  const getOptions = () => {
    if (props.element.isSearchAllowed) {
      return props.element.options && props.element.options.length > 0 && props.element.options.filter(option => {
        let matchStr = new RegExp(`${props.qtext}`, 'i');
        return (option.value || '').match(matchStr);
      })
    } else {
      return props?.element?.options && props?.element?.options?.length > 0 ? props?.element?.options : []
    }
  }

  return (
    <div className="" key={props.element._id}>
      <div className="leadform-field-label-wrap">
        <h3 className="leadform-field-label">{props.element.textElementName}</h3>
      </div>
      {
        props.isShowSearch ?
          <LeadFormSearch
            handleOptionSearch={props.handleOptionSearch}
            qtext={props.qtext}
          /> : null
      }
      <div className="vm-leadform-option-element-style">
        {getOptions()?.map((item) => (
          <OptionElement
            slideId={props.slideId}
            elementId={props.elementId}
            key={item._id}
            item={item}
            handleOptionSelect={props.handleOptionSelect}
            element={props.element}
            selectedIcon={props.selectedIcon}
            icon={props.icon}
          />
        ))}
      </div>
    </div>
  );
}
